module.exports = __webpack_public_path__ + "static/media/Danustan_Alphonza_goku_son.6d20c012.jpg";